import axios from '@/api/config';
// 民生资源录播、题库、直播js
const minShengCourseInfo = {
  getProductList(data) {
    return axios.post(`${process.env.BASE_URL}/minShengCourse/getProductList`, data);
  },
  getTeachplanListByProductId(data) {
    return axios.post(`${process.env.BASE_URL}/minShengCourse/getTeachplanListByProductId`, data);
  },
  getCourseListByTeachPlanId(data) {
    return axios.post(`${process.env.BASE_URL}/minShengCourse/getCourseListByTeachPlanId`, data);
  },
  getPeriodListByCourseId(data) {
    return axios.post(`${process.env.BASE_URL}/minShengCourse/getPeriodListByCourseId`, data);
  },
  getLessonListByStudent(data) {
    return axios.post(`${process.env.BASE_URL}/minShengCourse/getLessonListByStudent`, data);
  },
  getSubjectListByStudent(data) {
    return axios.post(`${process.env.BASE_URL}/minShengCourse/getSubjectListByStudent`, data);
  },
  getListPaperByStudent(data) {
    return axios.post(`${process.env.BASE_URL}/minShengCourse/getListPaperByStudent`, data);
  },
  getKnowledgeSystemTreeBySubject(data) {
    return axios.post(`${process.env.BASE_URL}/minShengCourse/getKnowledgeSystemTreeBySubject`, data);
  },
  getOpenQusetionInfoByKnowledgeSystemId(data) {
    return axios.post(`${process.env.BASE_URL}/minShengCourse/getOpenQusetionInfoByKnowledgeSystemId`, data);
  },
  getOpenModuleMaterialInfoByCourseId(data) {
    return axios.post(`${process.env.BASE_URL}/minShengCourse/getOpenModuleMaterialInfoByCourseId`, data);
  },
  getPaperDetailInfoByStudent(data) {
    return axios.post(`${process.env.BASE_URL}/minShengCourse/getPaperDetailInfoByStudent`, data);
  },
  exportExamExcel(data) {
    return axios.post(`${process.env.BASE_URL}/minShengCourse/exportExamExcel`, data);
  },
  exportKnowledgeExcel(data) {
    return axios.post(`${process.env.BASE_URL}/minShengCourse/exportKnowledgeExcel`, data);sss
  },
};

export default minShengCourseInfo;



// WEBPACK FOOTER //
// ./src/api/minShengCourseInfo.js